<template>
  <div class="content">
    <div class="calendar-header">
      <i class="iconfont icon-jiantou_liebiaoxiangzuo_o" @click="changeMoth(-1)"></i>
      <span>{{ yearMonth }}</span>
      <i class="iconfont icon-jiantou_liebiaoxiangyou_o" @click="changeMoth(1)"></i>
    </div>
    <div class="echart" id="gdEchart" ref="echart"></div>
  </div>
</template>

<script>
// import * as echarts from 'echarts'
import mixin from '@/mixins/mixin'
import { orderStatus } from '@/utils/dict'
export default {
  name: 'TaskOrder',
  mixins: [mixin],
  data () {
    return {
      yearMonth: this.$dayjs().format('YYYY-MM')
    }
  },
  watch: {
    projectId () {
      this.load()
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId || ''
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  created () {
    const month = this.$route.query.month
    if (month) {
      this.yearMonth = month
    }
    this.load()
  },
  methods: {
    changeMoth (num) {
      this.yearMonth = this.$dayjs(this.yearMonth).add(num, 'month').format('YYYY-MM')
      this.load()
    },
    load () {
      console.log('load')
      this.$axios.get(this.$apis.process.selectLcWorkOrderByCount, {
        projectId: this.projectId,
        yearMonth: this.yearMonth
      }).then((res) => {
        console.log(res);

        // const data = [{
        //   value: res.orderStatus0 || 0,
        //   name: '待反馈'
        // }, {
        //   value: res.orderStatus1 || 0,
        //   name: '待审核'
        // }, {
        //   value: res.orderStatus2 || 0,
        //   name: '已完成'
        // }, {
        //   value: res.orderStatus3 || 0,
        //   name: '已关闭'
        // }]
        // this.renderEchart(res)
        // this.renderEchart(data, res.orderTotal || 0)
        console.log('load task-order-init')
        this.$event.$emit('task-order-init', this.yearMonth)
      })
    },
    renderEchart (data) {
      const colors = ['#439aff', '#5dc56b', '#ff0000', '#ffe04d', '#a2a2a2']
      const chart = this.$getChartInstance('#gdEchart')
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          padding: [10, 5, 5, 5],
          itemWidth: 12,
          itemHeight: 10,
          textStyle: {
            fontSize: 11
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.nameList
        },
        yAxis: {
          type: 'value'
        },
        series: data.numList.map((item, index) => {
          return {
            name: orderStatus.get(String(index + 1)),
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            barWidth: 24,
            itemStyle: { color: colors[index] },
            emphasis: {
              focus: 'series'
            },
            data: item
          }
        })
      }
      chart.clear()
      chart.setOption(option)
    }
  }
}
</script>

<style scoped lang='scss'>
.content {
  .calendar-header {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      padding: 0 20px;
    }

    .iconfont {
      cursor: pointer;
    }
  }

  .echart {
    width: 100%;
    height: 230px;
  }
}
</style>
